import { Headphones, Play, X } from "lucide-react";

// Where a listen was interrupted, offered back the next time the page opens.
export const ResumeListen = ({ spot, onResume, onDismiss }) => {
  if (!spot?.stories?.length) return null;
  const story = spot.stories[spot.at] || spot.stories[0];
  const left = spot.stories.length - spot.at;

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 rounded-3xl border border-brand/30 bg-brand/[0.07] p-4"
         data-testid="resume-listen">
      <p className="flex min-w-0 items-center gap-2 text-xs text-ink-soft">
        <Headphones className="h-4 w-4 shrink-0 text-brand" />
        <span className="min-w-0" dir="auto">
          You stopped at <span className="font-semibold text-ink" data-testid="resume-listen-title">{story.title}</span>
          {left > 1 ? ` · ${left} stories left` : " · last one"}
        </span>
      </p>
      <button
        data-testid="resume-listen-play"
        onClick={onResume}
        className="ms-auto inline-flex min-h-[34px] items-center gap-1.5 rounded-full bg-brand px-4 text-xs font-semibold text-white transition-colors hover:bg-brand-hover active:scale-95"
      >
        <Play className="h-3.5 w-3.5" /> Pick it up
      </button>
      <button
        data-testid="resume-listen-dismiss"
        onClick={onDismiss}
        aria-label="Forget where I stopped"
        className="rounded-full border border-white/10 p-1.5 text-ink-soft transition-colors hover:text-ink"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
